module.exports = __webpack_public_path__ + "static/media/x_normal.5e05b0ba.svg";